import $ from "jquery";
import moment from "moment";
import { u_, vuwer } from "@@assets/scripts/common";
import "@@components/topicList";
import topicsData from "./__topicsData";

vuwer.add("topicsSection", {
	selector: "#topics_section",
	onReady($self) {
		if(!$self) {
			return false;
		}
		
		const $btnPrevMonth = $("#btn_prev_month");
		const $btnNextMonth = $("#btn_next_month");
		this.setProp({ $btnPrevMonth, $btnNextMonth });
	},
	
	async onChangeState(state) {
		const { ym } = state;
		if(ym && ym !== this.state.ym) {
			await this.get("topicList").setState({ ym });
			let date = moment(`${ym}-01`);
			date.isValid() || ( date = moment() );
			
			const prevMonth = date.clone().subtract(1, "months").format("YYYY-MM");
			this.$btnPrevMonth.attr({
				href: `./${u_.createQueryString({ ym: prevMonth })}`
			});
			
			const nextMonth = date.clone().add(1, "months").format("YYYY-MM");
			this.$btnNextMonth.attr({
				href: `./${u_.createQueryString({ ym: nextMonth })}`
			});
			
			$(".label-year").text( ym.substring(0, 4) + "年" );
		}
	}
}, function() {
	this.add("topicList", {
		vuwType: "topicList",
		selector: "#topic_list",
		async onChangeState(state) {
			const { ym } = state;
			if(ym) {
				const date = moment(`${ym}-01`);
				this.$self.attr({
					"data-ym": date.isValid() ? date.format("YYYY年MM月") : null
				});
				
				await this.renderList(ym);
			}
		}
	}, function() {
		this.setData(topicsData);
	});
});
